import { PageLoader } from '@/components/shared/PageLoader';
import { useAssetPreload } from '@/hooks/useAssetPreload';
import { ErrorBoundary } from '@components/shared/ErrorBoundary';
import GameContainer from '@features/game/components/GameContainer';

export default function SlidingPuzzlePage() {
  const { status, retry } = useAssetPreload();

  if (status === 'loading') {
    return (
      <div className="relative min-h-[100dvh] bg-[#0f172a]">
        <PageLoader />
      </div>
    );
  }

  if (status === 'offline') {
    return (
      <div className="flex flex-col items-center justify-center min-h-[100dvh] bg-[#0f172a] text-white">
        <h2 className="text-xl font-bold mb-4">No Internet Connection</h2>
        <p className="mb-6 opacity-80">Please check your connection and try again.</p>
        <button 
          onClick={retry}
          className="px-6 py-2 bg-sky-500 rounded-full font-semibold hover:bg-sky-400"
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <ErrorBoundary>
      <GameContainer />
    </ErrorBoundary>
  );
}
